import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import Climate from '@crehana/compass.icons.logos/Climate';
import HanaLight from '@crehana/compass.icons.logos/HanaLight';
import Learning from '@crehana/compass.icons.logos/Learning';
import Performance from '@crehana/compass.icons.logos/Performance';
import Recognition from '@crehana/compass.icons.logos/Recognition';
import ActivityCheck from '@crehana/compass.icons.outline/ActivityCheck';
import Administrate from '@crehana/compass.icons.outline/Administrate';
import AppsComments from '@crehana/compass.icons.outline/AppsComments';
import File from '@crehana/compass.icons.outline/File';
import Flag from '@crehana/compass.icons.outline/Flag';
import Gift from '@crehana/compass.icons.outline/Gift';
import Grid from '@crehana/compass.icons.outline/Grid';
import Home from '@crehana/compass.icons.outline/Home';
import Inbox from '@crehana/compass.icons.outline/Inbox';
import Note from '@crehana/compass.icons.outline/Note';
import OKRs from '@crehana/compass.icons.outline/OKRs';
import Presentation from '@crehana/compass.icons.outline/Presentation';
import Report from '@crehana/compass.icons.outline/Report';
import Report2 from '@crehana/compass.icons.outline/Report2';
import Settings2 from '@crehana/compass.icons.outline/Settings2';
import Stats from '@crehana/compass.icons.outline/Stats';
import SuccessionPlan from '@crehana/compass.icons.outline/SuccessionPlan';
import TrendingUp from '@crehana/compass.icons.outline/TrendingUp';
import { useFeatureFlag } from '@crehana/feature-flags/react';
import { FEATURE_FLAGS_V5 } from "../../featureFlags";
import { addProductsLabelSeparatorSubtitle } from "../../utils";
import { HelperTooltip } from "../../SidebarMenu/components";
import { MODULE_CODE_ADMIN } from "../../types";
import useAdminTranslations from "./useAdminTranslations";
import { useManageLinks } from "./useManageLinks";
import { jsx as _jsx } from "react/jsx-runtime";
export var Menu = {
  Admin: 'admin',
  Analytics: 'analytics',
  Climate: 'climate',
  Learning: 'learning',
  Performance: 'performance',
  Products: 'products',
  Recognitions: 'recognitions'
};
export var useUtils = function useUtils(_ref) {
  var _talentAdminModules$f;
  var organizationSlug = _ref.organizationSlug,
    talentAdminModules = _ref.talentAdminModules,
    withAdminPanelNavigation = _ref.withAdminPanelNavigation;
  var _useManageLinks = useManageLinks({
      organizationSlug: organizationSlug || '',
      adminSubmodules: ((_talentAdminModules$f = talentAdminModules.find(function (el) {
        return el.code === 'ADMIN';
      })) === null || _talentAdminModules$f === void 0 ? void 0 : _talentAdminModules$f.submodules) || [],
      withAdminPanelNavigation: withAdminPanelNavigation
    }),
    manageLinks = _useManageLinks.manageLinks;
  var _useAdminTranslations = useAdminTranslations(),
    t = _useAdminTranslations.t;
  var _useFeatureFlag = useFeatureFlag(FEATURE_FLAGS_V5.MODULE_HANA_AI),
    isHanaActive = _useFeatureFlag.flagValue;
  var getProductsLinks = function getProductsLinks(_ref2) {
    var backendTalentModules = _ref2.backendTalentModules,
      isLearningModuleActive = _ref2.isLearningModuleActive;
    var frontendModules = [{
      code: MODULE_CODE_ADMIN.HOME,
      label: t('MODULE_HOME'),
      icon: Home,
      arrowDefault: false,
      url: "/org/".concat(organizationSlug, "/panel/"),
      tooltip: t('MODULE_HOME')
    }, {
      code: MODULE_CODE_ADMIN.MAIN_ADMIN_ANALYTICS,
      label: t('MODULE_ANALYTICS'),
      icon: Stats,
      url: Menu.Analytics,
      arrowDefault: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_ANALYTICS'),
        description: t('MODULE_ANALYTICS_TOOLTIP_DESCRIPTION')
      })
    }, {
      code: MODULE_CODE_ADMIN.HANA_AI,
      label: t('MODULE_HANA'),
      icon: HanaLight,
      url: '/org/[slug]/panel/hana-ai',
      arrowDefault: false,
      decoratedIcon: true,
      isProductModule: true,
      hardInsert: isHanaActive,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_HANA'),
        description: t('MODULE_HANA_TOOLTIP_DESCRIPTION')
      })
    }, {
      code: MODULE_CODE_ADMIN.RECOGNITION,
      label: t('MODULE_RECOGNITION'),
      icon: Recognition,
      decoratedIcon: true,
      isProductModule: true,
      url: Menu.Recognitions,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_RECOGNITION'),
        description: t('MODULE_RECOGNITION_TOOLTIP_DESCRIPTION')
      })
    }, {
      code: MODULE_CODE_ADMIN.PERFORMANCE,
      label: t('MODULE_PERFORMANCE'),
      icon: Performance,
      decoratedIcon: true,
      url: Menu.Performance,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_PERFORMANCE'),
        description: t('MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION')
      })
    }, {
      code: MODULE_CODE_ADMIN.CLIMATE_ENGAGEMENT,
      label: t('MODULE_CLIMATE'),
      icon: Climate,
      decoratedIcon: true,
      url: Menu.Climate,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_CLIMATE'),
        description: t('MODULE_CLIMATE_TOOLTIP_DESCRIPTION')
      })
    }, {
      code: MODULE_CODE_ADMIN.E_LEARNING,
      label: t('MODULE_LEARNING'),
      icon: Learning,
      decoratedIcon: true,
      arrowDefault: true,
      url: Menu.Learning,
      isProductModule: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_LEARNING'),
        description: t('MODULE_LEARNING_TOOLTIP_DESCRIPTION')
      })
    }]
    // Merge with backend data
    .map(function (module) {
      var _backendTalentModule$;
      var backendTalentModule = backendTalentModules.find(function (talentModule) {
        return talentModule.code === module.code;
      });

      // Home is the only module that shouldn't be overridden by the backend data
      if (module.code === MODULE_CODE_ADMIN.HOME) {
        return module;
      }
      return _objectSpread(_objectSpread({}, module), {}, {
        label: (backendTalentModule === null || backendTalentModule === void 0 ? void 0 : backendTalentModule.label) || module.label,
        arrowDefault: !(backendTalentModule !== null && backendTalentModule !== void 0 && backendTalentModule.url),
        // We only override the URL if the backend provides it,
        url: (_backendTalentModule$ = backendTalentModule === null || backendTalentModule === void 0 ? void 0 : backendTalentModule.url) !== null && _backendTalentModule$ !== void 0 ? _backendTalentModule$ : module.url
      });
    });
    var backendModulesCodes = backendTalentModules.map(function (module) {
      return module.code;
    });
    if (isLearningModuleActive) {
      backendModulesCodes.push(MODULE_CODE_ADMIN.E_LEARNING);
    }
    var productsLinks = frontendModules.filter(function (frontendModule) {
      return backendModulesCodes.includes(frontendModule.code) || frontendModule.hardInsert;
    });
    var subtitle = t('MODULE_PRODUCTS_SUBTITLE');
    return addProductsLabelSeparatorSubtitle(productsLinks, subtitle);
  };
  var getFooterLinks = function getFooterLinks(_ref3) {
    var _backendModules$find;
    var backendModules = _ref3.backendModules,
      selectedModule = _ref3.selectedModule;
    var moduleCustomLabel = (_backendModules$find = backendModules.find(function (m) {
      return m.code === MODULE_CODE_ADMIN.ADMIN;
    })) === null || _backendModules$find === void 0 ? void 0 : _backendModules$find.label;
    return [{
      code: MODULE_CODE_ADMIN.ADMIN,
      label: moduleCustomLabel || t('MODULE_ADMIN'),
      icon: Administrate,
      url: Menu.Admin,
      arrowDefault: true,
      tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('MODULE_ADMIN'),
        description: t('MODULE_ADMIN_TOOLTIP_DESCRIPTION')
      })
    }].filter(function (el) {
      return el.url !== selectedModule;
    });
  };
  var getAdminLinks = function getAdminLinks() {
    return manageLinks;
  };
  var getSubmodules = function getSubmodules(_ref4) {
    var _backendModules$find$, _backendModules$find6;
    var backendModules = _ref4.backendModules,
      moduleCode = _ref4.moduleCode;
    var FRONTEND_NESTED_LINKS_DATA = {
      STADISTICS_ANALYTICS: {
        label: t('SUBMODULE_TALENT')
      },
      'E-Learning': {
        label: t('SUBMODULE_LEARNING')
      },
      REPORTS_ANALYTICS: {
        label: t('SUBMODULE_TALENT')
      },
      OKRS: {
        label: t('SUBMODULE_LINK_GOALS')
      },
      OKRS_ALIGNMENT: {
        label: t('SUBMODULE_LINK_ALIGNMENT')
      },
      OKRS_CONFIGURATION: {
        label: t('SUBMODULE_LINK_CONFIGURATION')
      },
      RECOGNITION_CONFIG_MEDALS: {
        label: t('SUBMODULE_CONFIGURATION_MEDALS')
      },
      RECOGNITION_CONFIG_MESSAGE: {
        label: t('SUBMODULE_CONFIGURATION_MESSAGES')
      },
      RECOGNITION_CONFIG_RULES: {
        label: t('SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS')
      }
    };
    var FRONTEND_MODULES_DATA = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MODULE_CODE_ADMIN.MAIN_ADMIN_ANALYTICS, [{
      code: 'ADMIN_ANALYTICS',
      label: t('SUBMODULE_RESULTS'),
      icon: Presentation,
      tooltip: {
        title: t('SUBMODULE_RESULTS'),
        description: t('SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'ADMIN_REPORTS_ANALYTICS',
      label: t('SUBMODULE_MY_TEAM'),
      icon: Report2,
      tooltip: {
        title: t('SUBMODULE_MY_TEAM'),
        description: t('SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'N_BOX',
      label: t('SUBMODULE_NBOX'),
      icon: Grid,
      tooltip: {
        title: t('SUBMODULE_NBOX'),
        description: t('SUBMODULE_NBOX_TOOLTIP_DESCRIPTION')
      }
    }].map(function (item) {
      var _backendModules$find2, _talentModule$url;
      var talentModule = (_backendModules$find2 = backendModules.find(function (_module) {
        return _module.code === MODULE_CODE_ADMIN.MAIN_ADMIN_ANALYTICS;
      })) === null || _backendModules$find2 === void 0 ? void 0 : _backendModules$find2.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        // Only replace the URL if the backend provides it
        url: (_talentModule$url = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url !== void 0 ? _talentModule$url : '',
        nested: talentModule !== null && talentModule !== void 0 && talentModule.url ? [] : talentModule === null || talentModule === void 0 ? void 0 : talentModule.submodules.map(
        // Format nested link
        function (backendNestedLink) {
          var _FRONTEND_NESTED_LINK;
          var url;
          var code;
          if (backendNestedLink.code === 'E-Learning') {
            code = item.code + backendNestedLink.code;
            if (item.code === 'ADMIN_ANALYTICS') {
              url = "/org/".concat(organizationSlug, "/panel/estadisticas/");
            }
            if (item.code === 'ADMIN_REPORTS_ANALYTICS') {
              url = "/org/".concat(organizationSlug, "/panel/reportes/");
            }
          }
          return {
            code: code || backendNestedLink.code,
            label: ((_FRONTEND_NESTED_LINK = FRONTEND_NESTED_LINKS_DATA[backendNestedLink.code]) === null || _FRONTEND_NESTED_LINK === void 0 ? void 0 : _FRONTEND_NESTED_LINK.label) || backendNestedLink.code,
            url: url || backendNestedLink.url || ''
          };
        }),
        tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
          title: item.tooltip.title,
          description: item.tooltip.description
        })
      });
    })), MODULE_CODE_ADMIN.RECOGNITION, [{
      code: 'RECOGNITION_RESULTS',
      label: t('SUBMODULE_ADMIN_RESULTS'),
      icon: Presentation,
      tooltip: {
        title: t('SUBMODULE_ADMIN_RESULTS'),
        description: t('SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'RECOGNITION_REQUESTS',
      label: t('SUBMODULE_MEDALS_REQUETS'),
      icon: Inbox,
      tooltip: {
        title: t('SUBMODULE_MEDALS_REQUETS'),
        description: t('SUBMODULE_MEDALS_REQUETS_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'RECOGNITION_REDEMPTION',
      label: t('SUBMODULE_REWARDS'),
      icon: Gift,
      tooltip: {
        title: t('SUBMODULE_REWARDS'),
        description: t('SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'RECOGNITION_CONFIGURATION',
      label: t('SUBMODULE_CONFIGURATION'),
      icon: Settings2,
      tooltip: {
        title: t('SUBMODULE_CONFIGURATION'),
        description: t('SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION')
      }
    }].map(function (submodule) {
      var _backendModules$find3, _backendSubModule$url;
      var backendSubModule = (_backendModules$find3 = backendModules.find(function (_module) {
        return _module.code === MODULE_CODE_ADMIN.RECOGNITION;
      })) === null || _backendModules$find3 === void 0 ? void 0 : _backendModules$find3.submodules.find(function (subLevelItem) {
        return subLevelItem.code === submodule.code;
      });

      // Only replace the URL if the backend provides it
      return _objectSpread(_objectSpread({}, submodule), {}, {
        label: (backendSubModule === null || backendSubModule === void 0 ? void 0 : backendSubModule.label) || submodule.label,
        url: (_backendSubModule$url = backendSubModule === null || backendSubModule === void 0 ? void 0 : backendSubModule.url) !== null && _backendSubModule$url !== void 0 ? _backendSubModule$url : '',
        nested: backendSubModule !== null && backendSubModule !== void 0 && backendSubModule.url ? [] : backendSubModule === null || backendSubModule === void 0 ? void 0 : backendSubModule.submodules.map(
        // Format nested link
        function (backendNestedLink) {
          var _FRONTEND_NESTED_LINK2;
          return {
            code: backendNestedLink.code,
            label: ((_FRONTEND_NESTED_LINK2 = FRONTEND_NESTED_LINKS_DATA[backendNestedLink.code]) === null || _FRONTEND_NESTED_LINK2 === void 0 ? void 0 : _FRONTEND_NESTED_LINK2.label) || backendNestedLink.code,
            url: backendNestedLink.url
          };
        }),
        tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
          title: submodule.tooltip.title,
          description: submodule.tooltip.description
        })
      });
    })), MODULE_CODE_ADMIN.PERFORMANCE, [{
      code: 'RESULTS_PERFORMANCE',
      label: t('SUBMODULE_RESULTS_PERFORMANCE'),
      icon: Presentation,
      tooltip: {
        title: t('SUBMODULE_RESULTS_PERFORMANCE'),
        description: t('SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'COMPETENCES',
      label: t('SUBMODULE_COMPETENCES'),
      icon: Report,
      tooltip: {
        title: t('SUBMODULE_COMPETENCES'),
        description: t('SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'GOALS',
      label: t('SUBMODULE_GOALS'),
      icon: Flag,
      tooltip: {
        title: t('SUBMODULE_GOALS'),
        description: t('SUBMODULE_GOALS_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'OKRS_PERFORMANCE',
      label: t('SUBMODULE_OKRS'),
      icon: OKRs,
      tooltip: {
        title: t('SUBMODULE_OKRS'),
        description: t('SUBMODULE_OKRS_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'FEEDBACK',
      label: t('SUBMODULE_FEEDBACK'),
      icon: AppsComments,
      tooltip: {
        title: t('SUBMODULE_FEEDBACK'),
        description: t('SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'PID',
      label: t('SUBMODULE_PID'),
      icon: TrendingUp,
      tooltip: {
        title: t('SUBMODULE_PID'),
        description: t('SUBMODULE_PID_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'SUCCESSION-PLAN',
      label: t('SUBMODULE_SUCCESSION_PLAN'),
      icon: SuccessionPlan,
      tooltip: {
        title: t('SUBMODULE_SUCCESSION_PLAN'),
        description: t('SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION')
      }
    }].map(function (submodule) {
      var _backendModules$find4, _backendSubModule$url2;
      var backendSubModule = (_backendModules$find4 = backendModules.find(function (_module) {
        return _module.code === MODULE_CODE_ADMIN.PERFORMANCE;
      })) === null || _backendModules$find4 === void 0 ? void 0 : _backendModules$find4.submodules.find(function (subLevelItem) {
        return subLevelItem.code === submodule.code;
      });

      // Only replace the URL if the backend provides it
      return _objectSpread(_objectSpread({}, submodule), {}, {
        label: (backendSubModule === null || backendSubModule === void 0 ? void 0 : backendSubModule.label) || submodule.label,
        url: (_backendSubModule$url2 = backendSubModule === null || backendSubModule === void 0 ? void 0 : backendSubModule.url) !== null && _backendSubModule$url2 !== void 0 ? _backendSubModule$url2 : '',
        nested: backendSubModule !== null && backendSubModule !== void 0 && backendSubModule.url ? [] : backendSubModule === null || backendSubModule === void 0 ? void 0 : backendSubModule.submodules.map(
        // Format nested link
        function (backendNestedLink) {
          var _FRONTEND_NESTED_LINK3;
          return {
            code: backendNestedLink.code,
            label: ((_FRONTEND_NESTED_LINK3 = FRONTEND_NESTED_LINKS_DATA[backendNestedLink.code]) === null || _FRONTEND_NESTED_LINK3 === void 0 ? void 0 : _FRONTEND_NESTED_LINK3.label) || backendNestedLink.code,
            url: backendNestedLink.url
          };
        }),
        tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
          title: submodule.tooltip.title,
          description: submodule.tooltip.description
        })
      });
    })), MODULE_CODE_ADMIN.CLIMATE_ENGAGEMENT, [{
      code: 'CLIMATE',
      label: t('SUBMODULE_CLIMATE_EVALUATION'),
      icon: ActivityCheck,
      tooltip: {
        title: t('SUBMODULE_CLIMATE_EVALUATION'),
        description: t('SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'SURVEY',
      label: t('SUBMODULE_SHORT_SURVEY'),
      icon: File,
      tooltip: {
        title: t('SUBMODULE_SHORT_SURVEY'),
        description: t('SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION')
      }
    }, {
      code: 'OTHERS',
      label: t('SUBMODULE_OTHER_EVALUATIONS'),
      icon: Note,
      tooltip: {
        title: t('SUBMODULE_OTHER_EVALUATIONS'),
        description: t('SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION')
      }
    }].map(function (item) {
      var _backendModules$find5, _talentModule$url2;
      var talentModule = (_backendModules$find5 = backendModules.find(function (_module) {
        return _module.code === MODULE_CODE_ADMIN.CLIMATE_ENGAGEMENT;
      })) === null || _backendModules$find5 === void 0 ? void 0 : _backendModules$find5.submodules.find(function (subLevelItem) {
        return subLevelItem.code === item.code;
      });

      // Only replace the URL if the backend provides it
      return _objectSpread(_objectSpread({}, item), {}, {
        label: (talentModule === null || talentModule === void 0 ? void 0 : talentModule.label) || item.label,
        url: (_talentModule$url2 = talentModule === null || talentModule === void 0 ? void 0 : talentModule.url) !== null && _talentModule$url2 !== void 0 ? _talentModule$url2 : '',
        tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
          title: item.tooltip.title,
          description: item.tooltip.description
        })
      });
    }));
    var submodulesCodes = ((_backendModules$find$ = (_backendModules$find6 = backendModules.find(function (_module) {
      return _module.code === moduleCode;
    })) === null || _backendModules$find6 === void 0 ? void 0 : _backendModules$find6.submodules) !== null && _backendModules$find$ !== void 0 ? _backendModules$find$ : []).map(function (_el) {
      return _el.code;
    });

    // This format is necessary to match the structure of the sidebar
    return _toConsumableArray(FRONTEND_MODULES_DATA[moduleCode].filter(function (el) {
      return (
        // Filter only the necessary submodules from the whole data
        submodulesCodes.includes(el.code)
      );
    }));
  };
  return {
    getSubmodules: getSubmodules,
    getAdminLinks: getAdminLinks,
    getFooterLinks: getFooterLinks,
    getProductsLinks: getProductsLinks
  };
};